import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { TasksService } from '../../../services/tasks/tasks.service';
import { UserPermissionsService } from '../../../services/user-permissions/user-permissions.service';

@Component({
  selector: 'dialog-reload-gda',
  templateUrl: './dialog-reload-gda.component.html',
  styleUrls: ['./dialog-reload-gda.component.scss'],
})
export class DialogReloadGDA implements OnInit, OnChanges {
  @Input() title: string;
  @Input() id: string;
  @Input() retributiveYear: string;

  @Output() uploadFileEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloseAction: EventEmitter<string> = new EventEmitter<string>();

  startDate: Date;
  endDate: Date;
  dateError: string = '';
  confirmationMsg: string = '';

  canConfirm: boolean = false;
  constructor(
    private tasksService: TasksService,
    private userPermissionsService: UserPermissionsService
  ) {}

  ngOnInit() {}

  ngOnChanges() {}

  objectKeys(paramObj) {
    return Object.keys(paramObj);
  }

  handleCloseDialog(): void {
    this.onCloseAction.emit(this.id);
  }

  checkDates() {
    this.canConfirm = false;
    if (!this.startDate || !this.endDate) {
      this.dateError = 'Ambas fechas son obligatorias';
    } else if (this.startDate > this.endDate) {
      this.dateError = 'La fecha inicial debe ser anterior a la fecha final';
    } else {
      this.confirmationMsg = `¿Está seguro de que desea volver a cargar los incurridos del transaccional correspondientes al período comprendido entre ${this.startDate} y ${this.endDate}? Los datos anteriores se borrarán y se actualizarán por los nuevos.`;
      this.dateError = '';
      this.canConfirm = true;
    }
  }

  onDateChange(): void {
    this.checkDates();
  }

  handleConfirm(): void {
    const sheet = {
      name: 'gda-incurred-reload',
      year: this.retributiveYear,
      extra: {
        start_date: this.startDate,
        end_date: this.endDate,
      },
    };
    this.tasksService.sheetsReload({ sheets: [sheet] });
    this.handleCloseDialog();
  }
}
